import React from "react";
import { Link } from "react-router-dom";
import "../Pages/Main.css";

function QuestBannerSlider() {
  const content = {
    label: "Pipeline Products",
    title: "Excellence Through Innovation",
    description:
      "Our dedicated R&D department is continuously working to bring you the latest advancements. Explore our wide range of healthcare programs and stay tuned for more exciting products coming soon.",
  };

  return (
    <section
      className="position-relative bg-image pt-60 pb-100 quest-hero-section"
      image-overlay="8"
    >
      <div
        className="background-image-wraper"
        style={{
          background: `url('/assets/img/QuestBanner.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 1,
        }}
      ></div>
      <div className="container">
        <div className="row align-items-center min-vh-75">
          <div className="col-lg-9 col-md-12">
            <div className="hero-glass-card p-5 hero-glass-animated">
              <span className="badge badge-primary mb-3 d-inline-block hero-glass-badge">
                {content.label}
              </span>
              <h1 className="font-weight-bold mb-4 hero-glass-title">
                {content.title}
              </h1>
              <p className="lead mb-4 hero-glass-description">
                {content.description}
              </p>
              <div className="action-btns hero-glass-buttons">
                <Link
                  to="/contact-us"
                  className="btn btn-brand-03 btn-rounded hero-glass-btn-primary"
                >
                  Contact Us
                  <i className="fas fa-arrow-right pl-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuestBannerSlider;
